const listeners = new Set<(messageId: string) => void>()
export function subscribeAttachmentAcknowledgements(listener: (messageId: string) => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
export function confirmAttachments(messageId: string): void {
  listeners.forEach((listener) => listener(messageId))
}
